import { action } from 'app/actions';

export const GET_PLANS_SCHEDULED = 'reports/GET_PLANS_SCHEDULED';
export const getPlansScheduled = payload => action(GET_PLANS_SCHEDULED, { payload });

export const GET_STATUS_PLAN_SCHEDULED = 'reports/GET_STATUS_PLAN_SCHEDULED';
export const getStatusPlanScheduled = (payload, meta) =>
  action(GET_STATUS_PLAN_SCHEDULED, { payload, ...meta });
